import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { historyPush } from 'reactApp/modules/router/router.module';
import { openSubscriptionsPage } from 'reactApp/utils/openHelpers';

interface IArgs {
    query?: string;
    anchor?: string;
    inSameTab?: boolean;
}

export const useGoToSubscriptions = ({ searchSuffix = '' } = {}) => {
    const dispatch = useDispatch();

    const goToSubscriptions = useCallback(({ query = '', anchor = '', inSameTab = true }: IArgs = {}) => {
        if (inSameTab) {
            let search = searchSuffix;
            if (query) {
                search = (search ? `${search}&` : '?') + query;
            }
            dispatch(historyPush({ id: '/subscriptions', search, hash: anchor }));
        } else {
            openSubscriptionsPage({ query, inSameTab, anchor });
        }
    }, []);

    return { goToSubscriptions };
};
